import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import getEmailFromLocalStorageProfileUtil from 'modules/profile/utils/get-profile-email-from-local-storage/index.js'
import shouldShowNewsletterSelectUtil from 'modules/newsletter/redux/selectors/should-show/utils/index.js'
import { createSelector } from 'reselect'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'
import isInLinksRouteSelect from 'modules/router/selectors/is-in-links/index.js'

const shouldShowNewsletterSelect = createSelector(
  getCurrentUserSelector(),
  getCurrentTrainingUserSelect,
  getRouteAndMatchRouterSelect,
  isInLinksRouteSelect,
  (
    user,
    trainingUser,
    { route },
    isInLinks
  ) => {
    return shouldShowNewsletterSelectUtil({
      user,
      trainingUser,
      email: getEmailFromLocalStorageProfileUtil(),
      route,
      isInLinks
    })
  }
)

export default shouldShowNewsletterSelect
